import { Injectable } from "@angular/core";
import { AuthService } from "../../../core/authentication/auth.service";
import { MenuItem } from "../../../shared/components/footer-navigation-bar/footer-navigation-bar.component";

export enum BqaRole {
  CustomerCareManager = "ccm",
  ConstructionManager = "cm"
}

export interface RoleOption {
  label: string;
  shortLabel: string;
  value: BqaRole;
  route: string;
  successMessage: string;
}

export interface ProfileSummary {
  userName: string;
}

@Injectable({
  providedIn: "root"
})
export class RoleSwitchService {
  readonly roleOptions: RoleOption[] = [
    {
      label: "Customer Care Manager",
      shortLabel: "CCM",
      value: BqaRole.CustomerCareManager,
      route: "/ccm/schedule",
      successMessage: "Switched to Customer Care Manager"
    },
    {
      label: "Construction Manager",
      shortLabel: "CM",
      value: BqaRole.ConstructionManager,
      route: "/cm/schedule",
      successMessage: "Switched to Construction Manager"
    }
  ];

  constructor(private authService: AuthService) { }

  hasRole(role: BqaRole): boolean {
    if (role === BqaRole.CustomerCareManager) {
      return !!this.authService.isCustomerCareManager?.();
    }

    return !!this.authService.isConstructionManager?.();
  }

  hasBothAssignableRoles(): boolean {
    return this.hasRole(BqaRole.CustomerCareManager) && this.hasRole(BqaRole.ConstructionManager);
  }

  getRoleFromUrl(url: string): BqaRole {
    return url.startsWith("/cm") ? BqaRole.ConstructionManager : BqaRole.CustomerCareManager;
  }

  getRoleOption(role: BqaRole): RoleOption {
    return this.roleOptions.find(option => option.value === role)!;
  }

  getProfileTab(activeRole: BqaRole): MenuItem {
    const activeRoleOption = this.getRoleOption(activeRole);

    return {
      tabName: "profile",
      itemText: activeRoleOption.shortLabel,
      itemIconUri: "assets/icons/profile.svg",
      route: `${activeRole}/profile`
    };
  }

  async getProfileSummary(): Promise<ProfileSummary> {
    const account = this.authService.currentAccount ?? null;

    return {
      userName: account?.username ?? "User name not available"
    };
  }
}